module.exports = __webpack_public_path__ + "c8d42b4a66554ca34d0385463f90354f.svg";